import StorageServiceFirebaseImpl from "../core/services/storageServiceFirebaseImpl";
import ApplicantFirebaseImpl from "../core/services/applicantFirebaseImpl";
import AuthServiceFirebaseImpl from "../core/services/authFirebaseImpl";
import UserFirebaseImpl from "../core/services/userFirebaseImpl";
import LogsFirebaseImpl from "../core/services/logsFirebaseImpl";
import CommentFirebaseImpl from "../core/services/commentFirebaseImpl";
import PositionFirebaseImpl from "../core/services/positionFirebaseImpl";
import NotificationFirebaseImpl from "../core/services/notificationFIrebaseImpl";
import InterviewerFirebaseImpl from "../core/services/interviewerFirebaseImpl";

import storageUsecases from "../core/usecases/interactors/storage";
import applicantUsecases from "../core/usecases/interactors/applicant";
import authUsecases from "../core/usecases/interactors/auth";
import userUsecases from "../core/usecases/interactors/user";
import logsUsecases from "../core/usecases/interactors/log";
import commentUsecase from "../core/usecases/interactors/comment";
import positionUsecase from "../core/usecases/interactors/position";
import notificationUsecase from "../core/usecases/interactors/notification";
import interviewerUsecase from "../core/usecases/interactors/interviewer";

const storageServiceRepo = new StorageServiceFirebaseImpl();
const applicantRepo = new ApplicantFirebaseImpl();
const authServiceRepo = new AuthServiceFirebaseImpl();
const userRepo = new UserFirebaseImpl();
const logsRepo = new LogsFirebaseImpl();
const commentRepo = new CommentFirebaseImpl();
const positionRepo = new PositionFirebaseImpl();
const notificationRepo = new NotificationFirebaseImpl();
const interviewerRepo = new InterviewerFirebaseImpl();

const storageInteractor = storageUsecases({
  storageServiceRepo,
});
const applicantInteractor = applicantUsecases({
  applicantRepo,
});
const authInteractor = authUsecases({
  authServiceRepo,
});
const userInteractor = userUsecases({
  userRepo,
});
const logsInteractor = logsUsecases({
  logRepo: logsRepo,
});
const commentInteractor = commentUsecase({
  commentRepo,
});
const positionInteractor = positionUsecase({
  positionRepo,
});
const notificationInteractor = notificationUsecase({
  notificationRepo,
});
const interviewerInteractor = interviewerUsecase({
  interviewerRepo,
});

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  storageInteractor,
  applicantInteractor,
  authInteractor,
  userInteractor,
  logsInteractor,
  commentInteractor,
  positionInteractor,
  notificationInteractor,
  interviewerInteractor,
};
